export default __webpack_public_path__ + "static/media/rotate_right_arrow.2a96893e.svg";